/* eslint-disable @typescript-eslint/no-unused-vars */
// ContentProps.tsx
import React, { useEffect, useMemo, useState } from 'react'
import { HeaderContent, HeaderMain, HeaderTitle } from './styles'
import InfoSend from '../../../components/InfoSend'
import { getDaysInMonth } from 'date-fns'
import { useMonthFilter } from '../../../context/FiltersContext/MonthFilter'

const WEEK_DAYS = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']

interface ContentPropsProps {
  activeFilter?: string
  onRegisterExport?: (exportFn: () => void) => void
}

function ContentProps({ activeFilter = 'all', onRegisterExport }: ContentPropsProps) {
  const { month: selectedMonth, year: selectedYear, distributorId } = useMonthFilter()
  const [deliveredDays, setDeliveredDays] = useState<number[]>([])

  const monthIndex = (() => {
    const m = Number(selectedMonth)
    if (isNaN(m)) return new Date().getMonth()
    return m > 11 ? m - 1 : m
  })()

  const year = Number(selectedYear) || new Date().getFullYear()

  const days = useMemo(() => {
    const totalDays = getDaysInMonth(new Date(year, monthIndex))
    return Array.from({ length: totalDays }, (_, i) => {
      const dayNumber = i + 1
      const dateObj = new Date(year, monthIndex, dayNumber)

      return {
        day: dayNumber,
        weekDay: WEEK_DAYS[dateObj.getDay()],
      }
    })
  }, [monthIndex, year])

  useEffect(() => {
    const fetchDeliveredDays = async () => {
      try {
        const params = new URLSearchParams({
          month: String(monthIndex + 1),
          year: String(year),
        })

        if (distributorId) {
          params.append('distributorId', distributorId)
        }
      } catch (err) {
        console.error('Erro ao buscar dias entregues:', err)
        setDeliveredDays([])
      }
    }

    fetchDeliveredDays()
  }, [monthIndex, year, distributorId])

  return (
    <>
      <HeaderMain>
        <HeaderTitle>
          <p className='header-text'>Geral Enviado</p>
          <div
            className='li'
            style={{
              transition: 'opacity 0.3s',
              opacity: activeFilter !== 'all' ? 0.4 : 1,
            }}
          >
            {days.map(({ day, weekDay }) => {
              return (
                <div
                  key={day}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '45px',
                    minWidth: '45px',
                  }}
                >
                  <span style={{ fontSize: '14px', fontWeight: '600' }}>
                    {String(day).padStart(2, '0')}
                  </span>
                  <span
                    style={{ fontSize: '10px', fontWeight: 'bold', textTransform: 'uppercase' }}
                  >
                    {weekDay}
                  </span>
                </div>
              )
            })}
          </div>
        </HeaderTitle>
        <HeaderContent>
          <InfoSend activeFilter={activeFilter} onRegisterExport={onRegisterExport} />
        </HeaderContent>
      </HeaderMain>
    </>
  )
}

export default ContentProps
